export const initialState = {
  applicants: [],
  applicant: null,
  student: null,
  isLoading: false,
  isLoadingStudent: false,
  isSaving: false,
  error: null,
};
